/**/
/*open-close brands-search-popup*/
(function () {
    $(document).ready(function () {
        const brandsSearchOpenBtn = $('#brands-search-open-btn'),
            brandsSearchCloseBtn = $('#brands-search-close-btn')
            brandsSearchMobile = $('#brandsSearchMobile'),
            body = $('body');

        brandsSearchOpenBtn.on('click', function (e) {
            // e.preventDefault();

            var $this = $(this);

            if ($this.hasClass('brands-search-open')) {
                brandsSearchMobile.removeClass('active');
                $this.removeClass('brands-search-open');
                body.removeClass('brands-search-open');
                body.removeClass('overflowY_hidden');
            } else {
                body.addClass('brands-search-open');
                body.addClass('overflowY_hidden');
                $this.addClass('brands-search-open');
                brandsSearchMobile.addClass('active');
            }
        });

        brandsSearchCloseBtn.on('click', function (e) {
            e.preventDefault();

            brandsSearchMobile.removeClass('active');
            brandsSearchOpenBtn.removeClass('brands-search-open');
            body.removeClass('brands-search-open');
            body.removeClass('overflowY_hidden');
        });
    });
})();
